/*
 * @Date: 2022-04-29 14:19:39
 * @LastEditTime: 2022-09-01 19:14:24
 * @Description: file content
 * @FilePath: \traffic\src\apis\pc\conversation\conversation.js
 */
import api from '../../api-request'

// 消息存档
// 企微客户列表（下拉框）
function getOutPeople(params) {
  return api.get('/chat-session/session/customer/listPage', { params })
}

// 企微客户、单聊会话列表
function externalList(params) {
  return api.post('/chat-session/session/external/list', params)
}

// 外部群会话列表
function externalGroupList(params) {
  return api.post('/chat-session/session/externalGroup/list', params)
}

// 会话聊天记录搜索
function chatSearch(params) {
  return api.post('/chat-session/session/chat/message', params)
}

// 同步
function messageSync() {
  return api.get('/chat-session/session/message/sync')
}

// 获取同步次数
function getSyncNum() {
  return api.get('/chat-session/session/sync/count')
}

// 获取当前员工开通消息存档
function getCurrentUserEnable(params) {
  return api.get('/traffic/chat/session/currentUser', { params })
}

// 内部员工单聊会话列表
function innerUserList(params) {
  return api.post('/chat-session/session/inner/list', params)
}

// 获取外部好友列表
const getUserList = (params) => {
  const sendParams = params
  return api.get('/traffic/chat/session/extendUserList', {
    params: sendParams
  })
};

// 通过extendUserId uid获取两人之间对话的sessionId
const getSessionId = (params) => {
  return api.post('/chat-session/session/external/list', params)
}

// 企微客户、单聊会话列表
function externaThirdlList(params) {
  return api.post('/chat-session/third/session/external/list', params)
}

// 外部群会话列表
function externalThirdGroupList(params) {
  return api.post('/chat-session/third/session/externalGroup/list', params)
}


// 会话聊天记录搜索--三方
function chatSearchThird(params) {
  return api.post('/chat-session/third/session/chat/message', params)
}

// 扫码授权智慧专区后,点击按钮
function programAuthCeck(params) {
  const reallyOid = window?.current_org?.oid || window?.AppConf?.org?.oid || window.top?.current_org?.oid
  return api.get('/traffic/program/auth/check',  {
    params: {
      oid: process.env.NODE_ENV === 'development' ? process.env?.OID : reallyOid
    }
  })
}


// 会话聊天记录上下文
function chatSearchThirdByAgainstConfigId(params) {
  return api.post('/chat-session/third/session/context/byAgainstConfigId', params)
}

export default {
  getOutPeople,
  externalList,
  externalGroupList,
  chatSearch,
  messageSync,
  getCurrentUserEnable,
  getSyncNum,
  innerUserList,
  getUserList,
  getSessionId,
  externaThirdlList,
  externalThirdGroupList,
  chatSearchThird,
  programAuthCeck,
  chatSearchThirdByAgainstConfigId,
}
